module.exports = __webpack_public_path__ + "img/Modal_sended.fafdea29.png";